import React from "react";
import {RiRectangleFill} from "react-icons/ri";
import neverLandUtils from "../../utils/NeverLandUtils";
import {getImage} from "../../constants/constants";


const MissingPlayerTable = ({teamData, team}) => {

  const getIconOfReason = (reason) => { // 결장 사유 아이콘 반환
    if (reason === "unfit" || reason === "injured" || reason === "other") // 빨간십자가
      return <img src={getImage('red_cross')} alt={'red_cross'} className="h-6 w-auto text-rose-600"/>

    if (reason === "injured-doubtful") // 노란 십자가
      return <img src={getImage('yellow_cross')} alt={'yellow_cross'} className="h-6 w-auto text-amber-400"/>

    if (reason === "suspended") // 레드카드
      return <RiRectangleFill className="h-6 w-auto text-rose-600 rotate-90"/>

    if (reason === "suspended-doubtful")
      return null; // 옐로카드 퇴장 확률 (띄우지 않음)
    return null;
  }

  return (
      <>
        <p className="text-xl py-2">{team === "home" ? "홈팀" : "원정팀"}</p>
        <table className="w-full border border-gray-900 text-sm">
          <thead
              className={neverLandUtils.classNames(team === "home" ? "bg-red-600" : "bg-blue-600", "text-white text-center")}>
          <tr>
            <th className="py-2">선수명</th>
            <th className="py-2 w-1/5">포지션</th>
            <th className="py-2 w-10">사유</th>
            <th className="py-2">상태(연속)</th>
            <th className="py-2">평점</th>
          </tr>
          </thead>

          <tbody className="divide-y divide-stone-300 text-center">
          {!teamData?.MISSING_PLAYER &&
              <tr className="h-4">
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
          }
          {teamData?.MISSING_PLAYER?.map((player, index) => {
            return (
                <tr key={index} className="h-4">
                  <td className="max-w-[5rem]">{player.name}</td>
                  <td>{player.position}</td>
                  <td className="h-full">
                    <div className="flex justify-center items-center h-full">
                      {getIconOfReason(player.reason)}
                    </div>
                  </td>
                  <td>{player.status}({player.cnt}{player.cnt >= 2 && "연속"})</td>
                  <td>{player.rate}</td>
                </tr>
            )
          })}
          </tbody>
        </table>
      </>
  )
}
export default MissingPlayerTable;